<template>
	<!-- <div class="py-4 container-fluid"> -->
	<div>
		<ToastPrime position="bottom-left" />
		<!-- MRC ITEM TABLE -->
		<div class="card mt-2" style="box-shadow: none !important">
			<div class="card-header py-2">
				<div class="d-flex align-items-center justify-content-between">
					<h6 class="mb-0">MCR ITEM</h6>
					<div class="col-4">
						<div class="d-flex align-items-center">
							<div class="ms-auto d-flex">
								<button v-if="mcrHeader?.status !== 'draft'" type="button" class="mx-1 mb-0 btn btn-sm btn-primary"
									@click="onTracking">Tracking</button>
								<button type="button" class="mx-1 mb-0 btn btn-sm btn-primary"
									@click="openImportDialog">Import</button>
								<button type="button" class="mx-1 mb-0 btn btn-sm btn-primary"
									@click="addNewItem">Add</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card-body pt-0 px-0" style="max-height: 400px; overflow-y: auto;">
				<DataTable :value="table.onLoad ? dummyRows : items" removable-sort scrollable scroll-height="flex"
					table-style="min-width: 50rem" selection-mode="single" :row-class="rowClass" class="p-datatable-sm"
					@row-select="onRowSelect">
					<Column header="" header-class="bg-light text-dark" style="width: 170px;">
						<template #body="slotProps">
							<Skeleton v-if="table.onLoad"></Skeleton>
							<div v-else style="display: inline-flex; align-items: center; gap: 4px;">
								<ButtonPrime
									v-tooltip.bottom="'MCR Item Note'"
									icon="pi pi-file-edit"
									rounded
									outlined
									size="small"
									@click.stop="openNoteModal(slotProps.data)"
								/>
								<ButtonPrime
									v-if="hasDuplicateSource(slotProps.data)"
									v-tooltip.bottom="'Check Duplicate'"
									icon="pi pi-copy"
									rounded
									outlined
									severity="warning"
									size="small"
									@click.stop="openCheckDuplicateDialog(slotProps.data)"
								/>
								<ButtonPrime
									v-tooltip.bottom="'Cancel'"
									icon="pi pi-ban"
									rounded
									outlined
									severity="danger"
									size="small"
									@click.stop="onCancelItem(slotProps.data)"
								/>
								<span
									v-if="slotProps.data.status"
									class="badge bg-secondary"
									style="font-size: 0.6rem; padding: 2px 4px; min-width: 0;"
								>{{ slotProps.data.status }}</span>
							</div>
						</template>
					</Column>
					<Column v-if="!isService" field="material_number" header="MATERIAL NUMBER" header-class="bg-light text-dark" sortable>
						<template #body="slotProps">
							<Skeleton v-if="table.onLoad"></Skeleton>
							<span v-else>{{ slotProps.data && slotProps.data.material_number ?
								formatMaterialNumber(slotProps.data.material_number) : '' }}</span>
						</template>
					</Column>
					<Column v-if="!isService" field="material_type" header="MATERIAL TYPE" header-class="bg-light text-dark" sortable>
						<template #body="slotProps">
							<Skeleton v-if="table.onLoad"></Skeleton>
							<span v-else>{{ slotProps.data && slotProps.data.material_type ?
								slotProps.data.material_type : '' }}</span>
						</template>
					</Column>
					<Column v-if="!isService" field="material_group" header="MATERIAL GROUP" header-class="bg-light text-dark" sortable>
						<template #body="slotProps">
							<Skeleton v-if="table.onLoad"></Skeleton>
							<span v-else>{{ slotProps.data && slotProps.data.material_group ?
								slotProps.data.material_group : '' }}</span>
						</template>
					</Column>
					<Column v-if="!isService" field="plant" header="PLANT" header-class="bg-light text-dark" sortable>
						<template #body="slotProps">
							<Skeleton v-if="table.onLoad"></Skeleton>
							<span v-else>{{ slotProps.data && slotProps.data.plant ? slotProps.data.plant : '' }}</span>
						</template>
					</Column>
					<Column v-if="isService" field="service_group" header="SERVICE GROUP" header-class="bg-light text-dark" sortable>
						<template #body="slotProps">
							<Skeleton v-if="table.onLoad"></Skeleton>
							<span v-else>{{ slotProps.data && (slotProps.data.service_group || slotProps.data.cat_service_group) ? (slotProps.data.service_group || slotProps.data.cat_service_group) : '' }}</span>
						</template>
					</Column>
					<Column v-if="isService" field="service_category" header="SERVICE CATEGORY" header-class="bg-light text-dark" sortable>
						<template #body="slotProps">
							<Skeleton v-if="table.onLoad"></Skeleton>
							<span v-else>{{ slotProps.data && (slotProps.data.service_category || slotProps.data.cat_service_category) ? (slotProps.data.service_category || slotProps.data.cat_service_category) : '' }}</span>
						</template>
					</Column>
					<Column field="uom" header="UOM" header-class="bg-light text-dark" sortable body-class="text-nowrap">
						<template #body="slotProps">
							<Skeleton v-if="table.onLoad"></Skeleton>
							<span v-else>{{ slotProps.data && slotProps.data.uom ? slotProps.data.uom : '' }}</span>
						</template>
					</Column>
					<Column field="specification" header="SPECIFICATION" header-class="bg-light text-dark" sortable>
						<template #body="slotProps">
							<Skeleton v-if="table.onLoad"></Skeleton>
							<span v-else>{{ slotProps.data && slotProps.data.specification ? slotProps.data.specification
								: '' }}</span>
						</template>
					</Column>
					<Column header="Actions" header-class="bg-light text-dark"
						body-style="text-align: center; width: 80px;">
						<template #body="slotProps">
							<Skeleton v-if="table.onLoad"></Skeleton>
							<div v-else>
								<ButtonPrime v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded severity="danger"
									size="small" @click="deleteItem(slotProps.data)" />
							</div>
						</template>
					</Column>
					<template #empty>
						<div style="text-align: center; padding: 40px 0;">
							<img src="/no_data.png" alt="No Data"
								style="max-width: 330px; opacity: 0.7; margin-bottom: 0;" />
							<div style="color: #888; font-size: 1.1em; font-weight: 500;">
								No Data
							</div>
						</div>
					</template>
				</DataTable>
			</div>
		</div>

		<!-- McrItemFormDialog (Reusable) -->
		<McrItemFormDialog
			ref="mcrItemDialog"
			:form-config="formConfig"
			:view-data="viewData"
			:client-code="clientCode"
			:company-code="companyCode"
			:mcr-type="mcrType"
			:max-validation="maxValidation"
			:readonly="false"
			:draft-id="$route.params.id"
			@saved="onItemDialogSaved"
		/>

		<!-- Dialog Import Excel (Reusable Component) -->
		<ImportExcelModal
			module="importExcel"
			width="65rem"
			dialog-class="mcr-import-modal"
			:import-id="viewData?.id"
			:import-service="importServiceFn"
			:show-success-inline="false"
			@close="onImportClose"
			@success="onImportSuccess"
		/>

		<!-- Dialog Tracking -->
		<DialogPrime v-model:visible="trackingModal.visible" modal :show-header="false" style="width: 50rem; margin: 10px;" @show="onTrackingShow">
			<Tracking ref="trackingRef" @close="trackingModal.visible = false" />
		</DialogPrime>

		<AddNoteItemModal
			v-model:visible="noteModal.visible"
			:item="noteModal.item"
			@saved="onNotesSaved"
		/>
		<CheckDuplicateModal
			v-model:visible="checkDuplicateModal.visible"
			:mcr-item="checkDuplicateModal.item"
			@saved="onStatusSaved"
		/>
	</div>
</template>

<script>
import userFormService from '@/services/materialCatalogingRequest/userFormService';
import draftListService from '@/services/materialCatalogingRequest/draftListService';
import formConfigService from '@/services/materialCatalogingRequest/formConfigService';
import cataloguerFormService from '@/services/materialCatalogingRequest/cataloguerFormService';
import formConfigHelper from '@/helpers/formConfig';
import api from "@/helpers/api";
import setMaxSize from "@/helpers/setMaxSize";
import { mapState } from "vuex";
import McrItemFormDialog from '@/components/McrItemFormDialog.vue';
import Tracking from '@/components/Tracking.vue';
import AddNoteItemModal from './modules/cataloguer/AddNoteItemModal.vue';
import CheckDuplicateModal from './modules/cataloguer/CheckDuplicateModal.vue';
import ImportExcelModal from '@/components/ImportExcelModal.vue';

export default {
	components: { McrItemFormDialog, Tracking, AddNoteItemModal, CheckDuplicateModal, ImportExcelModal },
	data() {
		return {
			selectedItemId: null,
			table: { onLoad: true },
			dummyRows: Array.from({ length: 10 }, () => ({})),
			items: [],
			viewData: null,
			isLoadingViewData: false,
			formConfig: null,
			importSuccessHandled: false,
			maxValidation: {
				size: 2000000,
				text: "Max Size 2000 KB"
			},
			clientCode:"",
			companyCode:"",
			trackingModal: {
				visible: false,
				mcrCode: '',
			},
			noteModal: {
				visible: false,
				item: null,
			},
			checkDuplicateModal: {
				visible: false,
				item: null,
			},
		};
	},
	computed: {
		...mapState({
			mcrHeader: (state) => state.mcr.mcrHeader,
			cataloguingFormConfig: (state) => state.mcr.cataloguingFormConfig,
		}),
		mcrType() {
			return (this.mcrHeader?.type || this.viewData?.type || '').toLowerCase().replace(/\s+/g, '-');
		},
		// Type EMCR mentah (tanpa normalisasi) — dipakai sebagai query param `type` di endpoint import
		emcrType() {
			return this.viewData?.type || this.mcrHeader?.type || '';
		},
		// Alur V2 = route yang dirender McrFormV2 (yang mengelola cataloguingFormConfig di store).
		// Alur legacy (route 'draft' → McrForm.vue) tidak mengelola store config, jadi store
		// hanya dipercaya di alur V2.
		isV2Flow() {
			return ['draft-v2', 'material-request', 'my-task'].some(seg => this.$route.path.includes(seg));
		},
		isService() {
			const t = (this.mcrType || '').toLowerCase();
			return t === 'mcr008' || t === 'mcr009' || t.includes('service');
		},
	},
	watch: {
		'$route.params': {
			handler(newQuery) {
				if (newQuery.id) {
					this.checkViewMode();
				}
			},
			immediate: false
		},
		mcrType: {
			handler(newVal) {
				if (newVal) this.fetchFormConfig();
			},
			immediate: true
		},
		// Config dari store (dimuat McrFormV2 sesuai alur: draft → mcr_drafting_config,
		// material/service request → mcr_process_config). Dipakai supaya dialog item
		// konsisten dengan keputusan render halaman (component_form_name), mis. MCR009.
		cataloguingFormConfig: {
			handler(val) {
				if (!this.isV2Flow) return;
				if (val?.tab_fields) {
					this.applyFormConfig(val);
				} else if (val === null) {
					this.formConfig = null;
				}
			},
		},
	},
	mounted() {
		const userAuth = JSON.parse(localStorage.getItem('userAuth') || '{}');
		this.clientCode = userAuth?.user?.client_code || '';
		this.companyCode = userAuth?.user?.company_code || '';
		this.table.onLoad = true;
		this.checkViewMode();
		this.getMaxSizeConfig();
	},
	methods: {
		async fetchFormConfig() {
			const mcrType = this.mcrHeader?.type || this.viewData?.type;
			if (!mcrType) return;
			// Prioritaskan config dari store (sudah dimuat McrFormV2 sesuai alur draft/process),
			// supaya dialog item tidak pakai config yang beda saat dibuka dari
			// Material/Service Request List (mcr_process_config) vs Draft (mcr_drafting_config).
			// Di alur legacy (McrForm draft) store config tidak dikelola → selalu fetch fresh.
			const storeConfig = this.isV2Flow ? this.cataloguingFormConfig : null;
			if (storeConfig?.tab_fields) {
				this.applyFormConfig(storeConfig);
				return;
			}
			try {
				const res = await api(this, formConfigService.getFormConfig({
					type_process: 'mcr_drafting_config',
					mcr_type: mcrType
				}), false);
				const raw = res?.data?.data || res?.data;
				// Jangan timpa config store yang lebih baru (dari alur McrFormV2)
				if (!this.isV2Flow || !this.cataloguingFormConfig?.tab_fields) {
					this.applyFormConfig(raw);
				}
			} catch (error) {
				console.error('Error fetching form config:', error);
			}
		},
		applyFormConfig(raw) {
			if (raw?.tab_fields) {
				this.formConfig = formConfigHelper.normalizeFormConfig(raw);
			}
		},
		onRowSelect(event) {
			this.selectedItemId = event.data.id;
			// masukkan item selected ke vue setSelectedMcrItem
			this.$store.commit('mcr/setSelectedMcrItem', event.data);
			// Buka dialog edit via komponen McrItemFormDialog
			this.$refs.mcrItemDialog?.openForEdit(event.data.id);
		},
		rowClass(data) {
			return this.selectedItemId === data.id ? 'row-active' : '';
		},
		openNoteModal(item) {
			this.noteModal.item = item;
			this.noteModal.visible = true;
		},
		onNotesSaved({ mcr_item_code, notes }) {
			const item = this.items.find((i) => i.mcr_item_code === mcr_item_code);
			if (item) item.emcr_item_note = notes;
		},
		// cat_po_horizontal biasanya belum terisi di tahap UserForm (baru diisi cataloguer),
		// jadi pengecekan duplikat di sini praktisnya cuma efektif lewat emcr_item_manufacturer (spn).
		hasDuplicateSource(data) {
			const hasLongDesc = !!(data?.cat_po_horizontal && data.cat_po_horizontal.trim());
			const hasSpn = Array.isArray(data?.emcr_item_manufacturer)
				&& data.emcr_item_manufacturer.some((m) => m?.spn && m.spn.trim());
			return hasLongDesc || hasSpn;
		},
		openCheckDuplicateDialog(item) {
			// CheckDuplicateModal baca cat_emcr_item_manufacturer; item mentah di sini cuma punya emcr_item_manufacturer.
			this.checkDuplicateModal.item = { ...item, cat_emcr_item_manufacturer: item.emcr_item_manufacturer || [] };
			this.checkDuplicateModal.visible = true;
		},
		onStatusSaved(data) {
			this.applyItemStatusUpdate(data);
		},
		async onCancelItem(item) {
			if (!item?.mcr_item_code) return;
			const result = await this.confirmDialog("This item will be canceled.", "cancel it");
			if (!result.isConfirmed) return;
			try {
				const response = await api(this, cataloguerFormService.updateItemStatus(item.mcr_item_code, { status: 'canceled', old_status: item.status, obj_catalogued_by: item.catalogued_by || {}, duplicated_with: { "duplicated-material": [], "duplicated-mpn": [] } }));
				this.applyItemStatusUpdate(response.data);
			} catch (error) {
				const httpStatus = error?.response?.status;
				const serverMsg = error?.response?.data?.message || error?.response?.data?.error;
				const detail = serverMsg || error?.message || 'Unknown error';
				const summary = httpStatus ? `Error ${httpStatus}` : 'Error';
				this.$toastNotifPrime('error', summary, detail);
			}
		},
		// Dipakai onStatusSaved (dari CheckDuplicateModal) dan onCancelItem.
		applyItemStatusUpdate(data) {
			if (!data?.mcr_item_code) return;
			// const isDuplicated = ['duplicated'].includes(data.status);
			// const patch = isDuplicated
			// 	? { status: data.status, catalogued_by: data.catalogued_by, material_number: data.material_number }
			// 	: { status: data.status, catalogued_by: data.catalogued_by };
			const patch = { status: data.status, catalogued_by: data.catalogued_by }

			const item = this.items.find((i) => i.mcr_item_code === data.mcr_item_code);
			if (!item) return;
			Object.assign(item, patch);
			if (this.checkDuplicateModal.item?.mcr_item_code === data.mcr_item_code) {
				this.checkDuplicateModal.item = { ...item, cat_emcr_item_manufacturer: item.emcr_item_manufacturer || [] };
			}
		},
		async checkViewMode() {
			const { id } = this.$route.params;
			if (id) {
				try {
					await this.fetchViewData(id);
				} catch (error) {
					this.$toastNotifPrime('error', 'Error', 'Failed to load view data');
				}
			}
		},
		async fetchViewData(id) {
			this.isLoadingViewData = true;
			this.table.onLoad = true;
			try {
				const response = await api(this, draftListService.detail(id), false);
				let details = null;
				if (response?.data?.data) {
					details = response.data.data;
				} else if (response?.data) {
					details = response.data;
				} else if (response) {
					details = response;
				}
				console.log("fetchViewData", JSON.stringify(details));
				if (details && details.emcr_item && Array.isArray(details.emcr_item)) {
					this.viewData = details;
					this.loadViewData();
				} else {
					this.$toastNotifPrime('error', 'Error', 'Invalid response structure from API');
				}
			} catch (error) {
				console.error('Error fetching view data:', error);
				this.$toastNotifPrime('error', 'Error', `Failed to fetch view data: ${error.message || 'Unknown error'}`);
				throw error;
			} finally {
				this.isLoadingViewData = false;
				this.table.onLoad = false;
			}
		},
		loadViewData() {
			if (!this.viewData || !this.viewData.emcr_item || this.viewData.emcr_item.length === 0) {
				this.items = [];
				return;
			}
			this.items = this.viewData.emcr_item;
			if (this.viewData.emcr_item.length > 1) {
				this.$toastNotifPrime('info', 'Multiple Items', `This MCR has ${this.viewData.emcr_item.length} items.`);
			}
		},
		deleteItem(item) {
			if (!item || !item.id) return;
			this.confirmDialog("Are you sure you want to delete this item?", "delete it").then(async (result) => {
				if (result.isConfirmed) {
					try {
						await api(this, userFormService.delete(item.id), true);
						if (this.$route.params.id) {
							await this.fetchViewData(this.$route.params.id);
						}
					} catch (error) {
						console.error('Error deleting item:', error);
					}
				}
			});
		},
		addNewItem() {
			this.$refs.mcrItemDialog?.openForAdd();
		},
		onItemDialogSaved() {
			// Refresh view data setelah item disimpan/diupdate
			if (this.$route.params.id) {
				this.fetchViewData(this.$route.params.id);
			}
		},
		onTracking() {
			this.trackingModal.mcrCode = this.$route.params.mcrCode || this.viewData?.mcr_code || '';
			this.trackingModal.visible = true;
		},
		// Dipanggil setelah DialogPrime selesai mount kontennya (ref sudah siap)
		onTrackingShow() {
			this.$refs.trackingRef?.getTracking({
				type: ['start', 'approval'],
				code: 'MCR',
				key: this.trackingModal.mcrCode,
				result: ['success', 'approve', 'send_back', 'reject'],
			});
		},
		// Import pakai ImportExcelModal (reusable) + Vuex module importExcel,
		// pola sama dengan MassUpdateMrpForm. File dikirim via props (:import-service).
		importServiceFn(id, file) {
			return userFormService.importEmcr(id, file, this.emcrType);
		},
		openImportDialog() {
			if (!this.viewData?.id) return;
			this.importSuccessHandled = false;
			this.$store.dispatch('importExcel/openDialog', {
				config: {
					title: 'Import Items',
					acceptTypes: '.csv,.xls,.xlsx',
					templateLabel: 'Download Template',
					importLabel: 'Import Items',
					cancelLabel: 'Cancel',
					showTemplateButton: false,
				},
			});
		},
		async onImportSuccess() {
			if (this.importSuccessHandled) return;
			this.importSuccessHandled = true;
			const successMsg = this.$store.state.importExcel?.successMessage || 'Import completed successfully';
			this.$store.dispatch('importExcel/closeDialog');
			this.$toastNotifPrime('success', 'Success', successMsg);
			if (this.$route.params.id) {
				await this.fetchViewData(this.$route.params.id);
			}
			this.importSuccessHandled = false;
		},
		onImportClose() {
			this.importSuccessHandled = false;
		},
		async getMaxSizeConfig() {
			try {
				const result = await setMaxSize();
				if (result) {
					this.maxValidation.size = result.data.data.maximum_file;
					this.maxValidation.text = `Max Size ${result.data.data.maximum_file / 1000} KB`;
				}
			} catch (error) {
				this.maxValidation.size = 2000000;
				this.maxValidation.text = `Max Size ${this.maxValidation.size / 1000} KB`;
			}
		},
	},
};
</script>

<style scoped>
:deep(.compact-table .p-datatable-tbody > tr > td) {
	padding: 0.35rem 0.5rem;
}

:deep(.compact-table .p-datatable-thead > tr > th) {
	padding: 0.4rem 0.5rem;
}

:deep(.p-datatable-sm .p-datatable-tbody > tr > td) {
	font-size: 0.875rem;
	padding: 0.35rem 0.5rem;
}

:deep(.p-datatable-sm .p-datatable-thead > tr > th) {
	font-size: 0.875rem;
	padding: 0.4rem 0.5rem;
}

:deep(.row-active) {
	background-color: #fff9db !important;
}

:deep(.row-active:hover) {
	background-color: #fff9db !important;
}


</style>